import styled from "@emotion/styled";

import { fontRobotoCondensed, fontSourceSerif4, theme } from "shared/lib/styles";

import { Figure } from "scmp-app/components/content/content-cover-image/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const StyledEntityLink = styled(EntityLink)`
  display: block;

  inline-size: 100%;

  color: #000000;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${theme.breakpoints.between("tablet", "desktop")} {
    display: grid;
    grid-template-columns: 0.5fr 0.5fr;
    gap: 20px;
    align-items: start;
  }
`;

export const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  min-inline-size: 0;
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  min-inline-size: 0;
`;

export const ExclusiveLabelContainer = styled.div`
  inline-size: fit-content;
`;

export const SectionLabel = styled.div`
  color: #333333;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: 100%;
  text-transform: uppercase;

  &:empty {
    display: none;
  }
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 600;
  font-size: 20px;
  font-family: ${fontSourceSerif4};
  line-height: 120%;
  letter-spacing: -0.4px;
`;

export const Summary = styled.div`
  color: #5a5a5a;
  font-weight: 500;
  font-size: 14px;
  font-family: ${fontSourceSerif4};
  line-height: 135%;
  letter-spacing: -0.14px;

  &:empty {
    display: none;
  }
`;

export const CoverImage = styled.div`
  min-inline-size: 0;

  ${Figure} {
    aspect-ratio: 3 / 2;
  }
`;
